import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_56: FaireProductEntity = {
  token: "starter_collection_56",
  type: "product",
  name: "Baby Sizzle (500ml)",
  brandName: "Graza",
  imageUrl: "",
  priceDollars: 10,
  msrpDollars: 20,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
